var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-loading","disabled":""}}):_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("确认")])}
var staticRenderFns = []

export { render, staticRenderFns }